export default "__VITE_ASSET__446d66c5__"